import React, { FC, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import styled from '@mui/styles/styled';
import { useAuth } from '../../hooks/useAuth';
import { AuthContext } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { authenticatedRoot } from '../../routers/AuthenticatedRoutes';
import { useTranslation } from 'react-i18next';

interface IProps {
  isOpen: boolean;
}

const Filler = styled('div')({
  flex: 1,
});

export const AuthChangedExternally: FC<IProps> = ({ isOpen }) => {
  const { logOut } = useAuth();
  const { resetChangedExternally } = useContext(AuthContext);
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen}>
      <DialogTitle>{t('auth.changedExternally.title')}</DialogTitle>
      <DialogContent>{t('auth.changedExternally.description')}</DialogContent>
      <DialogActions>
        <Button variant={'text'} onClick={logOut}>
          {t('auth.changedExternally.logOut')}
        </Button>
        <Filler />
        <Button variant={'outlined'} onClick={resetChangedExternally}>
          {t('auth.changedExternally.dismiss')}
        </Button>
        <Button component={Link} to={authenticatedRoot} variant={'contained'} onClick={resetChangedExternally}>
          {t('auth.changedExternally.goToMain')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
